import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
// Import Containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './pages/error/404.component';
import { P500Component } from './pages/error/500.component';
import { OpdListComponent } from './pages/general/opd-list/opd-list.component';
import { SekolahListComponent } from './pages/general/sekolah-list/sekolah-list.component';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { LoginComponent } from './pages/login/login.component';
import { AuthGuard } from './_services/auth/auth.guard';
import { SekolahListBopComponent } from './pages/general/sekolah-list-bop/sekolah-list-bop.component';
import { SekolahListBatasPengajuanComponent } from './pages/general/sekolah-list-batas-pengajuan/sekolah-list-batas-pengajuan.component';

const userId = JSON.parse(localStorage.getItem('currentUser'))
export const routes: Routes = [
  {
    path: '',
    redirectTo: 'landingpage',
    canActivate: [AuthGuard],
    pathMatch: 'full'
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },

  // route pertama
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'landingpage',
    component: LandingPageComponent,
    data: {
      title: 'Landing Page'
    }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    canActivate: [AuthGuard],
    children: [
      {
        path: 'list-opd',
        component: OpdListComponent,
        data: {
          title: 'DAFTAR OPD'
        }
      },
      {
        path: 'list-sekolah/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH'
        }
      },
      {
        path: 'list-sekolah/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH'
        }
      },
      {
        path: 'list-sekolah-persetujuan-tu/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Persetujuan Pembayaran BKU BOSP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-input/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Input BKU BOSP / Daftar Sekolah'

        }
      },
      {
        path: 'list-sekolah-detail/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'List Detail BKU BOSP / Daftar Sekolah'

        }
      },
      {
        path: 'list-sekolah-persetujuan-pa/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Persetujuan BKU BOSP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-token/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Permohonan Token BKU BOSP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-pengajuan/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Pengajuan Pembayaran BKU BOSP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-pembayaran/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Pembayaran BKU BOSP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-pembayaran-pajak/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Pembayaran Pajak BKU BOSP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-bap/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'BAP KAS BOSP / Daftar Sekolah ',
        }
      },
      {
        path: 'list-sekolah-bop/:sumberDana',
        component: SekolahListBopComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Input BKU BOP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-npd/:sumberDana',
        component: SekolahListBopComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Permohonan NPD / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-pengajuan-npd/:sumberDana',
        component: SekolahListBopComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Pengajuan Permohonan NPD / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-persetujuan-npd/:sumberDana',
        component: SekolahListBopComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Persetujuan NPD / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-pengajuan-bku/:sumberDana',
        component: SekolahListBopComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Pengajuan Pembayaran BKU BOP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-persetujuan-bku/:sumberDana',
        component: SekolahListBopComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Persetujuan BKU BOP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-permohonan-token/:sumberDana',
        component: SekolahListBopComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Permohonan Token / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-pembayaran-bku/:sumberDana',
        component: SekolahListBopComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Pembayaran BKU BOP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-pembayaran-pajak-bop/:sumberDana',
        component: SekolahListBopComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Pembayaran Pajak BKU BOP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-persetujuan-npd/:sumberDana',
        component: SekolahListBopComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Persetujuan NPD / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-dropping/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Dropping Dana BOSP/ Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-setoran/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Setor Pendapatan Lain-Lain BOSP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-cetak-setoran/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Cetak Setor / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-tutup-bku/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Tutup BKU / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-batal-tutup-bku/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Batal Tutup BKU / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-batal-tutup/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Batal Tutup BKU / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-persetujuan-setoran/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Persetujuan Setoran / Daftar Sekolah'
        },
      },
      {
        path: 'list-sekolah-bap-kas/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'BAP KAS BOP / Daftar Sekolah'
        },
      },
      {
        path: 'list-sekolah-batal-transfer-spj/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Batal Transfer SPJ BOSP / Daftar Sekolah'
        },
      },
      {
        path: 'list-sekolah-bap-kas-approval/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Persetujuan BA Pemeriksaan Kas / Daftar Sekolah'
        },
      },
      {
        path: 'list-sekolah-laporan-bku/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Laporan BKU BOSP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-mutasi-12/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Mutasi 12 Transaksi BOSP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-mutasi-semua/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Mutasi Semua Transaksi BOSP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-batal-transfer-spj-bop/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Batal Transfer BKU BOP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-persetujuan-batal-transfer-spj-bop/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Batal Transfer BKU BOP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-laporan-bku-bop/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'BKU BOP NEGERI',
          breadcrumb: 'Laporan BKU BOP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-mutasi-transfer-12-transaksi/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Mutasi 12 Transaksi BOP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-laporan-bku-bop-format-k1-k7/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'BKU BOP NEGERI',
          breadcrumb: 'Laporan BKU BOP (Format K1-K7) / Daftar OPD'
        }
      },
      {
        path: 'list-sekolah-koreksi-kode-akun-bop/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Koreksi Kode Akun Belanja BOP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-koreksi-nilai-belanja-bop/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Koreksi Nilai Belanja BOP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-mutasi-semua-bop/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Mutasi Semua Transaksi BOP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-setor-sisa-belanja/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Input Setoran BOP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-cetak-setoran/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Cetak Setor / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-cetak-setoran/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Persetujuan Setoran / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-pengecekan-data-rkas',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Pengecekan Data RKAS / Daftar Sekolah'

        }
      },
      {
        path: 'list-sekolah-konversi-data',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Konversi Data RKAS / Daftar Sekolah'

        }
      },
      {
        path: 'list-sekolah-detail-bku-bop/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'BKU BOP NEGERI',
          breadcrumb: 'Detail BKU BOP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-list-bku-bop/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'BKU BOP NEGERI',
          breadcrumb: 'List BKU BOP Sudin / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-helpdesk-pembayaran-bop/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Help Desk Pembayaran BKU BOP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-helpdesk-va-pln/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Help Desk Virtual Account PLN / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-helpdesk-pembayaran-bos/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Help Desk Pembayaran BKU BOSP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-batas-pengajuan',
        component: SekolahListBatasPengajuanComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Batas Pengajuan Pembayaran / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-persetujuan-sudin/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Persetujuan Pembayaran BKU BOSP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-pembayaran-pendapatan-lain-lain/:sumberDana',
        component: SekolahListComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Pembayaran Pendapatan Lain-Lain BOSP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-persetujuan-pendapatan-lain-lain/:sumberDana',
        component: SekolahListBopComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Persetujuan Pendapatan Lain-Lain BOP / Daftar Sekolah'
        }
      },
      {
        path: 'list-sekolah-pembayaran-pendapatan-lain-lain-bop/:sumberDana',
        component: SekolahListBopComponent,
        data: {
          title: 'DAFTAR SEKOLAH',
          breadcrumb: 'Pembayaran Pendapatan Lain-Lain BOP / Daftar Sekolah'
        }
      },
      {
        path: 'user-management',
        loadChildren: () => import('./pages/user-management/user-management.module').then(m => m.UserManagementModule)
      },
      {
        path: 'sekolah',
        loadChildren: () => import('./pages/sekolah/sekolah.module').then(m => m.SekolahModule)
      },
      {
        path: 'bos-negeri',
        loadChildren: () => import('./pages/bos-negeri/bos-negeri.module').then(m => m.BosNegeriModule)
      },
      {
        path: 'bop-negeri',
        loadChildren: () => import('./pages/bop-negeri/bop-negeri.module').then(m => m.BopNegeriModule)
      },
      {
        path: 'administrator',
        loadChildren: () => import('./pages/administrator/administrator-routing.module').then(m => m.AdministratorRoutingModule)
      },
      {
        path: 'bku-bop',
        loadChildren: () => import('./pages/bop-negeri/bop-negeri-routing.module').then(m => m.BopNegeriRoutingModule)
      },
    ]
  },
  { path: '**', component: P404Component }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    ToastrModule.forRoot()
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
